import React from 'react';
import { bool, shape, string } from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { educationalLayoutDataModel } from './dataModel';
import { EducationalLayoutRenderer } from './EducationalLayoutRenderer';

/**
 * Main job for this component is to fetch data. The useDataModel call will cause this component to rerender which is
 * why the rendering of the components is split into EducationalLayoutRenderer so that they don't unnecessarily
 * rerender. Rerendering components can result in extra API calls and processing, we do not want that.
 */
export const EducationalLayout = ({
  canonicalURL, customerType, pageId, storeId, pageTypeComponents, thdSEOBotDetection
}) => {

  const { data, loading, error } = useDataModel('educationalLayout', {
    variables: {
      slug: pageId,
      customerType,
    }
  });

  if (!data || loading || error) {
    return null;
  }

  return (
    <EducationalLayoutRenderer
      canonicalURL={canonicalURL}
      data={data}
      pageId={pageId}
      customerType={customerType}
      storeId={storeId}
      pageTypeComponents={pageTypeComponents}
      thdSEOBotDetection={thdSEOBotDetection}
    />
  );
};

EducationalLayout.displayName = 'EducationalLayout';

EducationalLayout.dataModel = educationalLayoutDataModel;

EducationalLayout.propTypes = {
  canonicalURL: string,
  customerType: string.isRequired,
  pageTypeComponents: shape({}).isRequired,
  pageId: string.isRequired,
  storeId: string.isRequired,
  thdSEOBotDetection: bool
};

EducationalLayout.defaultProps = {
  canonicalURL: null,
  thdSEOBotDetection: false
};
